import { Component, Input } from '@angular/core';
import { AnalyticsActionTypes } from '@analytics/models';
import { InnogyComponentRendering } from '@core/jss-models';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackErrorDirective } from '@analytics/events';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { CommonModule, LowerCasePipe } from '@angular/common';

@Component({
  selector: 'wl-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    TrackErrorDirective,
    RichTextWrapperComponent,
    LowerCasePipe,
  ],
})
export class InputErrorComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public messageDescription?: TextField | string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public messageField?: TextField | string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering?: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public label?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public errorType: AnalyticsActionTypes =
    AnalyticsActionTypes.USER_ERROR;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public automationId?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() toolName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;

  get description() {
    if (typeof this.messageDescription === 'string') {
      return this.messageDescription;
    } else {
      return this.messageDescription?.value;
    }
  }

  get field() {
    if (typeof this.messageField === 'string') {
      return this.messageField;
    } else {
      return this.messageField?.value;
    }
  }

  stripSymbols(string?: string) {
    return string?.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '');
  }
}
